module.exports = __webpack_public_path__ + "img/3.363ca36f.png";